import { Navigate } from 'react-router-dom'

export default function PaymentSettingsPage() {
  return <Navigate to="/cheki/setting" replace />
}
